export class ViewChart {
    static $inject = ['init'];
    constructor(init) {
        this.isLoading = true;
        Object.assign(this, init);
    }
}
ViewChart.$inject = ['init'];
